<h1 class="u-sr-only">{{ 'Toolkit.Assign.Title' | translate }}</h1>
<section class="c-section c-section--first c-section--last c-section--open c-section--static u-no-pb">
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<div class="c-card toolkit">
					<loader-overlay *ngIf="vm.loading"></loader-overlay>

					<div class="container container-narrow">
						<button class="btn-back" type="button" (click)="vm.close()">
							<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
							{{ 'Toolkit.Common.Back' | translate }}
						</button>

						<h1>{{ 'Toolkit.Assign.Title' | translate }}</h1>
						<p class="subtitle">
							<span *ngIf="vm.selectedClient">{{ 'Toolkit.Assign.To' | translate }} {{ vm.selectedClient.firstname }} {{ vm.selectedClient.lastname }}</span>
							<span *ngIf="!vm.selectedClient">{{ 'Toolkit.Assign.Subtitle' | translate }}</span>
						</p>

						<div class="toolkit__emptyPane" *ngIf="!vm.loading && vm.error">
							<div class="toolkit__emptyTitle">{{ 'Toolkit.Assign.LoadError.Title' | translate }}</div>
							<div class="toolkit__emptyText">{{ 'Toolkit.Assign.LoadError.Text' | translate }}</div>
						</div>

						<ng-container *ngIf="!vm.loading && !vm.error">
							<!-- Step 1: Select client -->
							<div class="assign-step" id="assignStep1" *ngIf="vm.step === 1">
								<h2 class="step-title"><span class="step-num">1</span> {{ 'Toolkit.Assign.Step1.Title' | translate }}</h2>
								<div class="search-box">
									<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#717680" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
									<input
										type="text"
										placeholder="{{ 'Toolkit.Assign.Client.SearchPlaceholder' | translate }}"
										spellcheck="false"
										[(ngModel)]="vm.clientSearch"
										(ngModelChange)="vm.applyClientFilter()">
								</div>

								<div class="assign-resource-list">
									<div
										class="assign-resource-item"
										*ngFor="let c of vm.filteredClients"
										(click)="vm.selectClient(c)">
										<div class="resource-info">
											<h3>{{ c.firstname }} {{ c.lastname }}</h3>
											<p>{{ c.email || '' }}</p>
										</div>
										<div class="check-circle"></div>
									</div>
								</div>

								<div *ngIf="!vm.filteredClients?.length" class="toolkit__emptyPane">
									<div class="toolkit__emptyTitle">{{ 'Toolkit.Assign.Client.Empty' | translate }}</div>
								</div>
							</div>

							<!-- Step 2: Personalize -->
							<div class="assign-step" id="assignStep2" *ngIf="vm.step === 2">
								<h2 class="step-title"><span class="step-num">2</span> {{ 'Toolkit.Assign.Step2.Title' | translate }}</h2>

								<div class="selected-resource-preview" *ngIf="vm.item">
									<div style="display:flex;align-items:center;gap:var(--tk-space-md, 16px);">
										<div class="toolkit__resourceIcon" [ngClass]="'toolkit__resourceIcon--' + (vm.item.format || vm.item.type || 'other')">
											<span [innerHTML]="formatIcon(vm.item.format || vm.item.type)"></span>
										</div>
										<div>
											<div class="font-bold">{{ vm.item.title || vm.item.name || vm.item.id }}</div>
											<div class="text-sm text-muted" *ngIf="vm.kind === 'resource'">
												{{ vm.theme?.icon || '' }} {{ vm.theme?.name || '' }}
												<span *ngIf="vm.item.durationMinutes != null"> · {{ vm.item.durationMinutes }} {{ 'Toolkit.Common.Minutes' | translate }}</span>
											</div>
										</div>
									</div>
								</div>

								<div class="form-group">
									<label>{{ 'Toolkit.Assign.Note.Label' | translate }}</label>
									<textarea [(ngModel)]="vm.note" placeholder="{{ 'Toolkit.Assign.Note.Placeholder' | translate }}" rows="4" required></textarea>
									<p class="form-hint">{{ 'Toolkit.Assign.Note.Hint' | translate }}</p>
								</div>

								<div class="form-group">
									<label>{{ 'Toolkit.Assign.DueDate.Label' | translate }}</label>
									<input type="date" class="form-input" [(ngModel)]="vm.dueAt">
								</div>

								<div class="form-group" *ngIf="vm.kind === 'assessment'">
									<label>
										<input type="checkbox" [(ngModel)]="vm.isBaseline">
										{{ 'Toolkit.Assign.Assessment.Baseline' | translate }}
									</label>
								</div>

								<div class="assign-actions">
									<button class="btn-outline" type="button" (click)="vm.goStep(1)">{{ 'Toolkit.Assign.ChangeClient' | translate }}</button>
									<button class="btn-outline" type="button" (click)="vm.preview()">{{ 'Toolkit.Common.Preview' | translate }}</button>
									<button class="btn-primary" type="button" [disabled]="vm.submitting" (click)="vm.confirmAssignment()">
										{{ vm.submitting ? ('Toolkit.Common.Loading' | translate) : ('Toolkit.Assign.Confirm' | translate) }}
									</button>
								</div>
							</div>

							<!-- Step 3: Confirmed -->
							<div class="assign-step" id="assignStep3" *ngIf="vm.step === 3">
								<div class="success-state">
									<div class="success-icon">
										<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#287638" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
									</div>
									<h2>{{ 'Toolkit.Assign.Done.Title' | translate }}</h2>
									<p class="text-muted">{{ 'Toolkit.Assign.Done.Text' | translate }}</p>
									<div class="assign-actions" style="justify-content:center;">
										<button class="btn-outline" type="button" (click)="vm.close()">{{ 'Toolkit.Assign.Done.Back' | translate }}</button>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
